import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from './redux/hooks';
import { selectUser } from './redux/reducers/userSlice';
import { Roles } from './models/User';

interface Props {
  authorizedRoles?: Roles[];
}

export const Protected: FC<PropsWithChildren<Props>> = ({ children, authorizedRoles }) => {
  const userRedux = useAppSelector(selectUser);

  if (!userRedux) {
    return <Navigate to={'/'} replace={true} />;
  }
  if (authorizedRoles && !userRedux?.roles?.some(role => authorizedRoles?.some(authRole => authRole === role?.name))) {
    return <Navigate to={'/'} replace={true} />;
  }

  return <>{children}</>;
};
